import styled, { css } from "styled-components";
import ListSubheader from '@material-ui/core/ListSubheader';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import LocalLibraryIcon from '@material-ui/icons/LocalLibrary';
import DomainIcon from '@material-ui/icons/Domain';
import DateRangeIcon from '@material-ui/icons/DateRange';
import CategoryIcon from '@material-ui/icons/Category';


import { BrandingWatermark, BrandingWatermarkOutlined, Description, DescriptionOutlined, Home, HomeOutlined, Settings, SettingsOutlined } from "@material-ui/icons";

export default function LeftMenu({ menu, setMenu }) {


  return (
    <Container >
      <List
        sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
        component="nav"
        aria-labelledby="nested-list-subheader"
        subheader={
          <ListSubheader component="h1" id="nested-list-subheader">
            Menu Penyaringan
          </ListSubheader>
        }
      >
        {
        /*
        <ListItem button>
          <ListItemIcon>
            <DomainIcon />
          </ListItemIcon>
          <ListItemText primary="Organizations" />
        </ListItem>
        <ListItem button>
          <ListItemIcon>
            <CategoryIcon />
          </ListItemIcon>
          <ListItemText primary="Type" />
        </ListItem>
        */
        }
        <ListItem button>
          <ListItemIcon>
            <DateRangeIcon />
          </ListItemIcon>
          <ListItemText primary="Tahun" />
        </ListItem>
        <ListItem button>
          <ListItemIcon>
            <LocalLibraryIcon />
          </ListItemIcon>
          <ListItemText primary="Kata Kunci" />
        </ListItem>
      </List>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
  flex-grow: 1;
`;


const ListMenu = styled.div`
  display:flex;
  flex-direction: column;
  margin-top:3px;
  overflow-y: auto;
  flex-grow: 1;
`;


const MenuTitle = styled.span`
  font-size: 14px;
  font-weight: 600;
  margin-left:15px;
`;

const Menu = styled.div`
  height: 64px;
  margin-bottom: 5px;
  display:flex;
  align-items: center;
  justify-content: flex-start;
  padding-left:25px;
  color:#555;

  &:hover{
    color:#000;
    background-color: #efefef;
    font-size: 50px;
  }

  &:active{
      background-color: #ddd;
      color: #2F4E6F;
  }

  ${props => props.active && css`
    background-color: #ddd;
    color: #2F4E6F;
    &:hover{
      background-color: #ddd;
      color: #2F4E6F;
    }
  `}
`;

const WrapperIcon = styled.div`
  border-left: 4px solid #2F4E6F;
  flex:1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const DescriptionIcon = styled(Description)``;
const DescriptionOutlinedIcon = styled(DescriptionOutlined)``;

const AnalysisIcon = styled(Settings)``;
const AnalysisOutlinedIcon = styled(SettingsOutlined)``;

const BrandingWatermarkIcon = styled(BrandingWatermark)``;
const BrandingWatermarkOutlinedIcon = styled(BrandingWatermarkOutlined)``;

/*
const StyledA = styled(Description)``

const DescriptionIcon = styled.div`
  ${StyledA} {
    border:solid 1px black;
    color:43
  }
`
*/
const Footer = styled.div`
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  padding:10px;
  background-color: #98B1C4;
  color:white;
`;

